import { CreditCardNetwork } from '@wix/cashier-common/dist/src/enums/payments/CreditCardNetwork';
import CVV3Digits from '../../../assets/img/cvv-3-digits.svg?url';
import CVV3or4Digits from '../../../assets/img/cvv-3-or-4-digits.svg?url';
import CVV4Digits from '../../../assets/img/cvv-4-digits.svg?url';
import CVV3DigitsRedesign from '../../../assets/img/cvv-3.svg?url';
import CVV4DigitsRedesign from '../../../assets/img/cvv-4.svg?url';

interface CardCVVFieldSettings {
  inputSize: number;
  placeholder: string;
  helperImageURL: string;
  helperTextKey: string;
}

export const getCardCVVSettingsByNetwork = (
  cardNetwork: CreditCardNetwork,
  customInput: boolean,
): CardCVVFieldSettings => {
  if (!customInput) {
    if (cardNetwork === CreditCardNetwork.Amex) {
      return {
        inputSize: 4,
        placeholder: 'card.cvv.placeholder.4',
        helperImageURL: CVV4DigitsRedesign,
        helperTextKey: 'card.cvv.help.dig4',
      };
    }

    if (cardNetwork) {
      return {
        inputSize: 3,
        placeholder: 'card.cvv.placeholder.3',
        helperImageURL: CVV3DigitsRedesign,
        helperTextKey: 'card.cvv.help.dig3',
      };
    }

    return {
      inputSize: 4,
      placeholder: 'card.cvv.placeholder.general',
      helperImageURL: CVV3DigitsRedesign,
      helperTextKey: 'card.cvv.help',
    };
  }

  if (cardNetwork === CreditCardNetwork.Amex) {
    return {
      inputSize: 4,
      placeholder: 'XXXX',
      helperImageURL: CVV4Digits,
      helperTextKey: 'card.cvv.help.dig4',
    };
  }

  if (cardNetwork) {
    return {
      inputSize: 3,
      placeholder: 'XXX',
      helperImageURL: CVV3Digits,
      helperTextKey: 'card.cvv.help.dig3',
    };
  }

  return {
    inputSize: 4,
    placeholder: 'XXX',
    helperImageURL: CVV3or4Digits,
    helperTextKey: 'card.cvv.help',
  };
};
